import PropTypes from 'prop-types';
import { commonPropTypes, } from '../../interfaces/commonProps';
import { spacingPropTypes, } from '../../interfaces/layoutProps';
export const buttonGroupPropTypes = {
    block: PropTypes.bool,
    variant: PropTypes.oneOf([
        'block-buttons',
        'text-buttons',
    ]).isRequired,
    ...commonPropTypes,
    ...spacingPropTypes,
};
//# sourceMappingURL=ButtonGroup.types.js.map